import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export function useLiveLtp(open, stock, exchange) {
  const [ltp, setLtp] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    const sym = (stock || "").trim().toUpperCase();
    if (sym.length < 2) { setLtp(null); return; }
    setLoading(true);
    const handle = setTimeout(async () => {
      try {
        const { data } = await api.get("/prices/quote", { params: { symbol: sym, exchange: exchange || "NS" } });
        setLtp(data);
      } catch (_e) {
        setLtp({ error: true });
      } finally {
        setLoading(false);
      }
    }, 500);
    return () => { clearTimeout(handle); setLoading(false); };
  }, [open, stock, exchange]);

  return { ltp, loading };
}

export default function LtpBadge({ ltp, loading, onUse }) {
  if (loading) return <span className="text-[10px] text-[#71717A] tracking-wider">…</span>;
  if (ltp?.error) return <span className="text-[10px] text-[#FFB800] tracking-wider">N/A</span>;
  if (!ltp?.last) return null;
  const up = ltp.change_pct >= 0;
  const tone = up ? "text-[#00C805] border-[#00C805]/40 bg-[#00C805]/10" : "text-[#FF3B30] border-[#FF3B30]/40 bg-[#FF3B30]/10";
  return (
    <button type="button" data-testid="use-ltp-btn" onClick={() => onUse(String(ltp.last))} title="Use LTP as entry rate"
      className={`num text-[11px] px-1.5 py-0.5 rounded-sm border hover:brightness-125 ${tone}`}>
      ₹{ltp.last}
    </button>
  );
}
